var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._t("trigger"),_c('transition',_vm._g({attrs:{"name":"move"}},_vm.transition),[_vm._t("default")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }